import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from 'app/core/services/auth/auth.service';
import { BaseAuthService } from 'app/core/services/base-auth.service';
import { SearchResult } from 'app/search/shared/models/search-result.model';

@Injectable()
export class SearchService extends BaseAuthService {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }

  getSearchResults(parameters: Object, fresh = false): Observable<SearchResult[]> {
    return this.get('search_mysql', parameters).pipe(
      map(searchResults => searchResults.map(searchResult => SearchResult.fromObject(searchResult)))
    );
  }
}
